import React from "react";
import CapacitacionesComp from "../components/capacitacionescomp";
import NavbarFacach from "../components/NavbarFacach";
import FooterFacach from "../components/FooterFacach";
import banner from "../assets/fotos/capacitacion_portada.png";
import { Container, Row, Col, Card, Image, Button } from "react-bootstrap";
import "../components/capacitacionmain.css";
import SocialBar from "../components/SocialBar";
import { Link } from "react-router-dom";
import { useSiteSettings } from '../hooks/useSiteSettings';
import fallbackBanner from '../assets/imagen.jpg';
import { useState, useEffect } from "react";



const Capacitaciones = () => {

  const [plans, setPlans] = useState([]);

useEffect(() => {
  fetch("https://facach.coop.hn/training-plans")
    .then(r => r.json())
    .then(json => { if (json.ok) setPlans(json.data); })
    .catch(err => console.error("Error cargando planes:", err.message));
}, []);

  const { settings } = useSiteSettings();
  const bannerSrc = settings.banner_image
    ? `https://facach.coop.hn${settings.banner_image}`
    : fallbackBanner;




  return (
    <>
      <Container fluid className="p-0 capacitacion-page" style={{ overflowX: "hidden" }}>
        <NavbarFacach />

        <div className="banner-wrapper">
          <Image src={bannerSrc} alt="..." fluid className="banner-image" />
          <div className="banner-overlay">
            <h1 className="banner-title">CAPACITACIÓN</h1>
            <p className="banner-description">

            </p>
          </div>
        </div>
        <br />
        <Row className="justify-content-center">
          <Col xs={12} md={8} className="text-center">
            <h2 className="at-section-title">Nuestros Servicios</h2>
            <p className="at-section-subtitle">
              Impulsamos procesos de formación especializada, liderazgo y desarrollo
              de habilidades que fortalecen a sus cooperativas afiliadas, extendiendo
              también este apoyo a cooperativas no afiliadas. A través de programas
              diseñados con un enfoque práctico, creando espacios de aprendizaje y
              crecimiento profesional que promueven la formación continua y generan
              un impacto directo en el desarrollo integral y sostenible del sector
              cooperativo hondureño.
            </p>
          </Col>
        </Row>


        <div style={{
          padding: "60px 24px",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Decoraciones de fondo */}
          <div style={{
            position: "absolute", top: -80, right: -80,
            width: 350, height: 350, borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
          }} />
          <div style={{
            position: "absolute", bottom: -100, left: -60,
            width: 450, height: 450, borderRadius: "50%",
            background: "rgba(255,255,255,0.03)",
          }} />

          <Container style={{ position: "relative", zIndex: 1 }}>
            <Row className="justify-content-center g-4">
              {plans.map(plan => (
                <Col md={5} key={plan.id}>
                  <div style={{
                    background: "linear-gradient(135deg, #252a58 0%, #3a4280 100%)",
                    backdropFilter: "blur(10px)",
                    borderRadius: 20, padding: "36px 32px",
                    border: "1px solid rgba(255,255,255,0.15)",
                    height: "100%", display: "flex", flexDirection: "column",
                    transition: "transform 0.2s, box-shadow 0.2s",
                  }}
                    onMouseEnter={e => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 48px rgba(0,0,0,0.25)"; }}
                    onMouseLeave={e => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
                  >
                    <div style={{ display: "flex", alignItems: "flex-start", gap: 10, marginBottom: 16 }}>
                      <div style={{ width: 4, flexShrink: 0, height: 36, borderRadius: 2, background: "linear-gradient(180deg, #f9c31f, #f47920)", marginTop: 2 }} />
                      <h3 style={{ color: "#fff", fontWeight: 900, fontSize: 16, margin: 0, lineHeight: 1.4, letterSpacing: 0.3 }}>
                        {plan.title}
                      </h3>
                    </div>

                    <p style={{ color: "rgba(255,255,255,0.88)", fontSize: 14, lineHeight: 1.7, margin: "0 0 24px", flex: 1 }}>
                      {plan.description}
                    </p>

                    {plan.file_url ? (
                      <a href={plan.file_url} target="_blank" rel="noopener noreferrer"
                        className="btn-plan-descarga">
                         Descargar documento
                      </a>
                    ) : (
                      <span style={{
                        display: "inline-flex", alignItems: "center",
                        background: "rgba(255,255,255,0.08)",
                        color: "rgba(255,255,255,0.4)", fontWeight: 700, fontSize: 13,
                        padding: "11px 20px", borderRadius: 10,
                        border: "1px solid rgba(255,255,255,0.1)",
                        alignSelf: "flex-start", cursor: "not-allowed",
                      }}>Próximamente</span>
                    )}
                  </div>
                </Col>
              ))}
            </Row>
          </Container>
        </div >

        <CapacitacionesComp />

        <div className="boton-centro my-3">
          <Button
            variant="primary"
            as={Link}
            to="/contacto_capacitacion"
            className="w-25"
          >
            Contáctanos para obtener más información
          </Button>
        </div>

        <div className="boton-centro my-3">
          <Button

            as="a"
            href="/documentos/catalogo.pdf"
            target="_blank"
            rel="noopener noreferrer"
            variant="link"
            className="producto-vermas-link mt-auto p-0"

            style={{

              color: "#252A58",
              textAlign: "center",
              border: "0px solid, #252A58",
              opacity: "0.90",
            }}
          >
            Haz clic para ver nuestro Catálogo 
          </Button>
        </div>


        <br />
        {/* Botón llamativo cursos gratuitos */}
        <div style={{
          background: "linear-gradient(135deg, #252A58)",
          padding: "48px 24px",
          textAlign: "center",
          position: "relative",
          overflow: "hidden",
        }}>
          {/* Decoración */}
          <div style={{
            position: "absolute", top: -40, left: -40,
            width: 180, height: 180, borderRadius: "50%",
            background: "rgba(255,255,255,0.05)",
          }} />
          <div style={{
            position: "absolute", bottom: -60, right: -20,
            width: 240, height: 240, borderRadius: "50%",
            background: "rgba(255,255,255,0.04)",
          }} />

          <div style={{
            display: "inline-block",
            background: "linear-gradient(135deg, #ffc107)",
            color: "#1a2a45",
            fontSize: 12, fontWeight: 900,
            padding: "5px 18px",
            borderRadius: 20,
            letterSpacing: 1,
            marginBottom: 16,
            animation: "none",
          }}>TOTALMENTE GRATIS</div>

          <h2 style={{
            color: "#fff",
            fontSize: "clamp(1.6rem, 3vw, 2.4rem)",
            fontWeight: 900,
            marginBottom: 12,
            textShadow: "0 2px 12px rgba(0,0,0,0.2)",
          }}>¿Quieres seguir aprendiendo?</h2>

          <p style={{
            color: "rgba(255,255,255,0.85)",
            fontSize: "clamp(0.95rem, 1.8vw, 1.1rem)",
            maxWidth: 520,
            margin: "0 auto 32px",
            lineHeight: 1.6,
          }}>
            Accede a nuestros cursos gratuitos en video y fortalece tus conocimientos sobre el sector cooperativo
          </p>

          <Link to="/cursos-gratuitos" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 12,
            background: "#fff",
            color: "#252A58",
            fontWeight: 900,
            fontSize: 16,
            padding: "16px 40px",
            borderRadius: 50,
            textDecoration: "none",
            boxShadow: "0 8px 28px rgba(0,0,0,0.25)",
            transition: "all 0.2s",
            position: "relative",
            zIndex: 1,
          }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = "translateY(-3px) scale(1.03)";
              e.currentTarget.style.boxShadow = "0 14px 36px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = "translateY(0) scale(1)";
              e.currentTarget.style.boxShadow = "0 8px 28px rgba(0,0,0,0.25)";
            }}
          >
            Ver Cursos Gratuitos
            
          </Link>
        </div>
        <SocialBar position="right" top="35%" size={42} rounded={true} />
        <FooterFacach />
      </Container >
    </>
  );
};

export default Capacitaciones;
